var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningUpgrade = function SvgWarningUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.73 1 19.052 33a2 2 0 0 1-1.732 3H2.945a2 2 0 0 1-1.732-3L20.266 1a2 2 0 0 1 3.464 0Zm-3.732 26v4h4v-4h-4Zm0-14v10h4V13h-4Z",
    fill: "#FF6B0F"
  })));
};

export default SvgWarningUpgrade;